export default __webpack_public_path__ + "static/media/1814.9269336c.png";